import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e3a57226&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e3a57226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a57226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3a57226')) {
      api.createRecord('e3a57226', component.options)
    } else {
      api.reload('e3a57226', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e3a57226&scoped=true&", function () {
      api.rerender('e3a57226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20E113LHZtKiR/JS/comp/SearchFilterTokens.vue"
export default component.exports